import axiosInstance from "@/lib/axiosInstance";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import { accessEndpoints } from "./access.endpoints";

/** One temporary role, held until the end of `endsOn` (a calendar date) in New York. */
export type TemporaryRoleWrite = { roleId: string; endsOn: string };

/**
 * With the access engine on, the user create and update calls refuse temporary roles and point
 * here instead, and this route works with the engine off too, so it is the one write path.
 */
export const addTemporaryRole = async (
  userId: string,
  write: TemporaryRoleWrite,
  /** The company the role belongs to, when it is an entity's own copy: the route looks the role up there. */
  actingEntityId?: string,
) => {
  await axiosInstance.post(accessEndpoints.temporaryRoles(userId), write, {
    suppressErrorAlert: true,
    ...(actingEntityId ? { actingEntityId } : {}),
  } as CustomAxiosRequestConfig);
};

/**
 * Ends a temporary role now. The user update's `removedRoleIds` only deletes rows with no end
 * date, so a temporary role is never removed that way.
 */
export const endTemporaryRole = async (
  userId: string,
  userRoleId: string,
  /** The role's own company: the route only finds a temporary role there. */
  actingEntityId?: string,
) => {
  await axiosInstance.delete(`${accessEndpoints.temporaryRoles(userId)}/${userRoleId}`, {
    suppressErrorAlert: true,
    ...(actingEntityId ? { actingEntityId } : {}),
  } as CustomAxiosRequestConfig);
};
